var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"material-Input-View"},[_c('PageTitle',{attrs:{"imagem":"bottles.png","main":"Plano de Consumo de Insumos","sub":""}}),_c('MaterialInputViewTable')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }